import { OMS_BUSINESS_TOOLS_SPEND_BY_DEPARTMENT_PATH, OMS_BUSINESS_TOOLS_SPEND_BY_ITEMS_PATH, OMS_BUSINESS_TOOLS_SPEND_BY_JOB_NAME_PATH, OMS_BUSINESS_TOOLS_SPEND_BY_QUANTITY_PATH, OMS_BUSINESS_TOOLS_SPEND_BY_STORE_PATH, } from '../../constants/paths';
import { apiBase } from '../axios-client';
export var TopSpendByJobNameAPI = function (requestData) {
    return apiBase.post(OMS_BUSINESS_TOOLS_SPEND_BY_JOB_NAME_PATH, requestData);
};
export var TopSpendByStoreAPI = function (requestData) {
    return apiBase.post(OMS_BUSINESS_TOOLS_SPEND_BY_STORE_PATH, requestData);
};
export var TopSpendByDepartmentAPI = function (requestData) {
    return apiBase.post(OMS_BUSINESS_TOOLS_SPEND_BY_DEPARTMENT_PATH, requestData);
};
export var TopSpendByItemSpendAPI = function (requestData) {
    return apiBase.post(OMS_BUSINESS_TOOLS_SPEND_BY_ITEMS_PATH, requestData);
};
export var TopSpendByItemQuantityAPI = function (requestData) {
    return apiBase.post(OMS_BUSINESS_TOOLS_SPEND_BY_QUANTITY_PATH, requestData);
};
